import axios from "axios";
import { config } from "../config";
import { getAccountDetails } from "../Components/Services/localStorage";
import { encryptRequest, decryptResponse, isEncryptedEnvelope } from "./apiCrypto";

const instance = axios.create()

instance.interceptors.request.use(
  async function (reqConfig) {
    const { accessToken } = getAccountDetails();
    reqConfig.headers.authorization = `Bearer ${accessToken}`;

    // Skip file uploads (FormData) - binary bodies aren't JSON-encryptable
    // the same way, and are already carried over HTTPS.
    if (config.enableApiEncryption && !(reqConfig.data instanceof FormData)) {
      try {
        const { envelope, encryptedKeyB64, rawAesKey } = await encryptRequest(reqConfig.data);
        reqConfig.headers["X-Encrypted"] = "true";
        reqConfig.headers["X-Encrypted-Key"] = encryptedKeyB64;
        if (envelope) {
          reqConfig.data = envelope;
        }
        // Stashed on the config (not sent anywhere) so the response
        // interceptor below can decrypt this request's matching reply.
        reqConfig.__aesKey = rawAesKey;
      } catch (err) {
        console.error("Request encryption failed - sending request unencrypted:", err);
      }
    }

    return reqConfig
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async function (response) {
    if (config.enableApiEncryption && response.config?.__aesKey && isEncryptedEnvelope(response.data)) {
      try {
        response.data = await decryptResponse(response.data, response.config.__aesKey);
      } catch (err) {
        console.error("Response decryption failed:", err);
      }
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default instance;
